// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#ff7171","root":"Button_root__2TCoZ","secondary":"Button_secondary__1LfJY","disabled":"Button_disabled__xk6Qi"};